import React, { useEffect } from 'react';
import styled from 'styled-components'
import { __ } from '@wordpress/i18n';
import { H4 } from '../../ui/style';
import './style.scss';

const Typography = styled.div`
    font-size: 16px;
    line-height: normal;
    color: #757575;

    ${props => props.large && `
        font-size: 32px;
        color: #3B3F5C;
		margin-bottom: 6px;
	`}

	${props => props.font && `
		font-family: ${props.font};
	`}
`;

const UL = styled.ul`
    margin: 0;
    padding: 0;
`

const LI = styled.li`
	padding: 22px;
	border-radius: 5px;
	margin-bottom: 15px;
	cursor: pointer;
    background: #F8FAFF;
    border: 2px solid #E6E6E6;
    ${props => props.active && `
        border-color: #B8CBFF;
    `}

    &:hover {
        border-color: #B8CBFF;
    }

`

const List = ({ className, options, onSelect, selected }) => {
    return (
        <UL className={`ist-font-selector ${className}`}>
            {
                Object.keys(options).map(index => {
                    let bodyFont = getFontName(options[index]["body-font-family"]) || '';
                    let headingFont = getFontName(options[index]["headings-font-family"], bodyFont) || '';
                    let preview = options[index]["preview"] || '';
                    let id = options[index]["id"] || '';
                    return (
                        <LI
                            className="ist-font"
                            key={id}
                            active={id == selected ? true : false}
                            onClick={(event) => {
                                onSelect(id);
                            }}
                        >
                            { '' !== preview
                                ?
                                <img src={preview} />
                                :
                                <>
                                    {
                                        headingFont ? <Typography font={headingFont} large>{headingFont}</Typography> : ''}
                                    {bodyFont ? <Typography font={bodyFont}>{bodyFont}</Typography> : ''}
                                </>
                            }
                        </LI>
                    )
                })}
        </UL>
    )
}

export const getFontName = (fontName, inheritFont) => {
    if (!fontName) {
        return '';
    }
    let matches = fontName.match(/'([^']+)'/);

    if (matches) {
        return matches[1];
    }

    if (inheritFont) {
        return inheritFont;
    }

    return fontName;
}

const FontSelector = ({ selected, options, onSelect }) => {

    useEffect(() => {

        if (!document.getElementById('google-fonts-domain')) {
            const node = document.createElement('link');
            node.id = 'google-fonts-domain';
            node.setAttribute('rel', 'preconnect');
            node.setAttribute('href', 'https://fonts.gstatic.com');
            document.head.appendChild(node);
        }

        if (!document.getElementById('google-fonts-url')) {
            const node = document.createElement('link');
            node.id = 'google-fonts-url';
            node.setAttribute('rel', 'stylesheet');

            let fonts = [];
            Object.keys(options).map(index => {
                let bodyFont = options[index]['body-font-family'] || '';
                if (bodyFont) {
                    bodyFont = getFontName(bodyFont);
                    bodyFont = bodyFont.replace(' ', '+');
                    fonts.push(`family=${bodyFont}`)
                }

                let headingFont = options[index]['headings-font-family'] || '';
                if (headingFont) {
                    headingFont = getFontName(headingFont, bodyFont);
                    headingFont = headingFont.replace(' ', '+');
                    fonts.push(`family=${headingFont}`)
                }

                // @todo Add font weight, variation support as: fonts.push(`family=${fontName}:wght@300`)
            });

            let fontUrl = `https://fonts.googleapis.com/css2?${fonts.join('&')}&display=swap`;

            node.setAttribute('href', fontUrl);
            document.head.appendChild(node);
        }
    }, []);

    let fonts = options.map((font, index) => {
        font.id = index;
        return font;
    });
    let defaultFonts = fonts.filter((font) => font.default);
    let otherFonts = fonts.filter(font => !font.default);

    return (
        <>
            <H4>{__('Default Fonts:', 'astra-sites')}</H4>
            <List className="ist-default-fonts" options={defaultFonts} onSelect={onSelect} selected={selected} />

            <H4>{__('You can also try:', 'astra-sites')}</H4>
            <List className="ist-other-fonts" options={otherFonts} onSelect={onSelect} selected={selected} />
        </>
    )
}

export default FontSelector;
